export enum AccountingType {
  BUDGET = 1,
  ECONOMY = 2
}

export enum AccountingTypeLabel {
  BUDGET = 'budget',
  ECONOMY = 'economy'
}
